module.exports = __webpack_public_path__ + "img/charts.31296b2d.svg";